if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        /* Added by Jared B | 6 Dec 2024 */
        // Check if currentBundle exists and is non-empty to determine if bundle logic should be applied
        if (
          typeof window.currentBundle !== "undefined" &&
          !Object.values(window.currentBundle)
            .filter((value) => typeof value === "object" && value !== null)
            .every(
              (value) =>
                typeof value === "object" && Object.keys(value).length === 0
            )
        ) {
          // Bundle product: Build and send JSON payload including bundle items
          this.addBundleToCart();
        } else {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
            });
        }
        /* End of addition by by Jared B | 6 Dec 2024 */
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      /* Added by Jared B | 6 Dec 2024 */
      addBundleToCart() {
        const config = fetchConfig("javascript");
        config.headers["Content-Type"] = "application/json";
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        // Create FormData object from the form
        const formData = new FormData(this.form);

        // Build the items array
        const items = [];

        // Get base product data
        const variantId = formData.get("id");
        if (!variantId) {
          console.error("Variant ID not found in the form data.");
          return;
        }

        const quantity = formData.get("quantity") || "1";

        // Include bundle items from window.currentBundle
        if (typeof window.currentBundle !== "undefined") {
          for (const accessoryKey in window.currentBundle.accessories) {
            const accessory = window.currentBundle.accessories[accessoryKey];
            items.push({ id: parseInt(accessory.variantId, 10), quantity: 1 });
          }
          for (const projectId in window.currentBundle.projects) {
            const project = window.currentBundle.projects[projectId];
            for (const colorKey in project.colors) {
              const color = project.colors[colorKey];
              items.push({
                id: parseInt(color.variantId, 10),
                quantity: parseInt(color.quantity, 10),
              });
            }
          }
        }

        // Add base product
        items.push({
          id: parseInt(variantId, 10),
          quantity: parseInt(quantity, 10),
        });

        // Prepare the request body
        const bodyData = {
          items: items,
        };

        // Build query parameters for sections
        let fetchUrl = `${routes.cart_add_url}.js`;

        if (this.cart) {
          const sections = this.cart
            .patternBundlerGetSectionsToRender()
            .map((section) => section.id)
            .join(",");
          const sectionsUrl = encodeURIComponent(window.location.pathname);

          fetchUrl += `?sections=${sections}&sections_url=${sectionsUrl}`;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(bodyData);

        fetch(fetchUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(
                "Cart Error:",
                response.errors || response.description
              );
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error && this.cart) {
                this.cart.patternBundlerRenderContents(response);
              }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.patternBundlerRenderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.patternBundlerRenderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }
      /* End of addition by by Jared B | 6 Dec 2024 */
    }
  );
}
